export const REDIRECT_URI = `${window.location.origin}/sign-in`;
